// extracted by mini-css-extract-plugin
export default {"tooltip":"Bo-z","sharingV2":"Co-z","sharingIconsV2":"Do-z","links":"Eo-z","link":"Fo-z","facebookV2":"Go-z","twitterV2":"Ho-z","pinterestV2":"Io-z"};